<template>
    <nav
        class="navbar has-shadow lb-project-header"
        role="navigation"
        aria-label="main navigation"
        @click.stop
    >
        <div class="container is-fluid is-paddingless mx-1">
            <div class="navbar-brand is-shrinkable">
                <div class="navbar-item is-shrinkable"></div>
                <a
                    role="button"
                    class="navbar-burger"
                    aria-label="menu"
                    aria-expanded="false"
                    @click="menuActive = !menuActive"
                >
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a>
            </div>
            <div
                :class="{ 'is-active': menuActive }"
                class="navbar-menu"
                @click="menuActive = false"
            >
                <div
                    v-if="$store.getters.canCreateSessions"
                    class="navbar-item has-text-centered"
                >
                    <a
                        v-t="'project.create_session'"
                        class="pr-3"
                        @click="$emit('update:sessionCreation', true)"
                    />
                </div>
                <div
                    v-if="$store.getters.canCreateSessions"
                    class="navbar-item has-text-centered"
                >
                    <a
                        v-t="'project.simulate_session'"
                        @click="$emit('update:sessionSimulation', true)"
                    />
                </div>
                <div
                    class="navbar-start"
                    style="flex-grow: 1; justify-content: center"
                ></div>
                <div class="navbar-end pr-3">
                    <a
                        v-if="
                            hasAdminPermission &&
                            $store.getters.canCreateSessions
                        "
                        class="navbar-item has-text-centered"
                        @click="$emit('update:showSessions', true)"
                        >{{ $t('project_own_session_option') }}</a
                    >
                    <a
                        v-if="canViewChanges"
                        class="navbar-item has-text-centered"
                        @click="$store.dispatch('Project/toggleChanges')"
                    >
                        {{ $t('project_history_option') }}
                        <span
                            v-if="project.pendingChanges"
                            class="badge lb-project-header-badge"
                            >{{ project.pendingChanges }}</span
                        >
                    </a>
                    <a
                        v-if="hasSchool"
                        class="navbar-item has-text-centered"
                        @click="$store.dispatch('Project/toggleComments')"
                    >
                        {{ $t('project_commments_option') }}
                        <span
                            v-if="project.pendingComments"
                            class="badge lb-project-header-badge"
                            >{{ project.pendingComments }}</span
                        >
                    </a>
                    <a
                        v-if="hasAdminPermission"
                        v-t="'project_participants_option'"
                        class="navbar-item has-text-centered"
                        @click="$store.dispatch('Project/toggleParticipants')"
                    />
                    <a
                        v-t="'project_configuration_option'"
                        class="navbar-item has-text-centered"
                        @click="$emit('update:showConfiguration', true)"
                    />
                    <a
                        v-if="hasAdminPermission"
                        v-t="'project_privacy_option'"
                        class="navbar-item has-text-centered"
                        @click="$store.dispatch('Project/togglePrivacy')"
                    />
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import _ from 'underscore';
import { isLightColor } from '@/lib/helpers';
import AppSearchBar from '@/components/AppSearchBar';
export default {
    components: {
        AppSearchBar,
    },
    model: 'textSearch',
    props: {
        textClass: {
            type: String,
            default: '',
        },
        textSearch: {
            type: String,
            default: '',
        },
        typeFilter: {
            type: String,
            default: '',
        },
        sessionCreation: {
            type: Boolean,
            default: false,
        },
        showSessions: {
            type: Boolean,
            default: false,
        },
        showConfiguration: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            menuActive: false,
            searchDropdownOptions: [
                this.$t('Constants.FILTER_OPTION_ALL'),
                this.$t('Constants.FILTER_OPTION_MINE'),
                this.$t('Constants.FILTER_OPTION_MENTIONED'),
                this.$t('Constants.FILTER_OPTION_COMMENTED'),
                this.$t('Constants.FILTER_OPTION_LIKED'),
            ],
            filter: this.$t('Constants.FILTER_OPTION_ALL'),
        };
    },
    computed: {
        content() {
            return _.pick(this.$store.getters.project, 'title');
        },
        project() {
            return this.$store.getters.project;
        },
        isTrivial() {
            return this.project.type == 'trivial';
        },
        projectURL() {
            return window.location.href;
        },
        hasAdminPermission() {
            return this.$store.getters.project.accessLevel == 'administrator';
        },
        canViewChanges() {
            if (
                this.project.owner &&
                this.hasSchool &&
                this.$store.getters.isTeacher
            ) {
                return (
                    this.hasAdminPermission ||
                    this.project.owner.school._id ==
                        this.$store.getters.user.school._id
                );
            }
            return this.hasAdminPermission;
        },
        hasSchool() {
            return this.$store.getters.hasSchool;
        },
    },
    watch: {
        filter() {
            this.$emit('update:typeFilter', this.filter);
        },
    },
};
</script>
<style scoped lang="sass">
.lb-project-header
  background-color: rgba(255,255,255, 0.8)
  z-index: 1
</style>
